module.exports = __webpack_public_path__ + "img/message_icon.8e4d6599.svg";